module.exports = __webpack_public_path__ + "img/gallery_inactive.6c37eb19.svg";